import { storeToRefs } from "pinia"
import useToastManager from "@/composables/toastManager"
import { useProjectsStore } from "@/stores/projects"
import projectService from "@/services/project.service"
import AddSidebarProjectHandler from "./AddSidebarProjectHandler"
import { useUserAccountsStore } from "../../stores/userAccounts"

class CreateProjectHandler {
  static render() {
    const { isOpenCreateModal } = storeToRefs(useProjectsStore())
    isOpenCreateModal.value = true
  }

  static async apply(title, router) {
    const { userAccount } = storeToRefs(useUserAccountsStore())

    try {
      const projectCreated = await projectService.create({
        payload: { name: title, owner: userAccount.value.iri }
      })

      AddSidebarProjectHandler.apply(projectCreated)

      useToastManager().success({
        message: `${title} project created`
      })

      if (router) router.push({ name: "project", params: { uuid: projectCreated.uuid } })

      return projectCreated
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default CreateProjectHandler
